import React from 'react'
import PropTypes from 'prop-types'
import { Editor } from 'react-draft-wysiwyg'

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'


const Form = props => (
  <form className="form-horizontal" role="form" onSubmit={props.addEmail(props.data)}>
    <div className="portlet light">
      <div className="portlet-title">
        <div className="caption">
          <span className="caption-subject bold uppercase">Add a new email</span>
        </div>
      </div>
      <div className="portlet-body">
        <div className="form-body">
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
                The content of the email is
              </label>
            <div className="col-md-4">
              <Editor
                mention={{
                  separator: ' ',
                  trigger: '@',
                  suggestions: [
                      { text: 'PROJECT NAME', value: '{{projectName}}' },
                  ],
                }}
                editorState={props.editorState}
                onEditorStateChange={props.handleEditorChange(props.data)}
                toolbarClassName="rdw-storybook-toolbar"
                wrapperClassName="rdw-storybook-wrapper"
                editorClassName="rdw-storybook-editor"
                toolbar={{
                  colorPicker: {
                    className: undefined,
                    component: undefined,
                    popupClassName: undefined,
                    colors: ['rgb(128,128,128)', 'rgb(255,83,74)', 'rgb(77,77,77)', 'rgb(69,173,168)'],
                  },
                }}
              />
            </div>
            <div
              className="col-md-5"
              dangerouslySetInnerHTML={{ __html: props.concateTemplate }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
                The subject of the email is
              </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter subject"
                value={props.data.subject}
                name="subject"
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
                The category of the email is
              </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter category"
                value={props.data.category}
                name="category"
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
                The group of the email is
              </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter group"
                value={props.data.group}
                name="group"
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
                The type of the email is
              </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter type"
                value={props.data.type}
                name="type"
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-actions">
            <div className="row">
              <div className="col-md-offset-3 col-md-9">
                <button type="submit" className="btn btn-lg btn-primary">Submit</button>
                <button
                  type="button"
                  className="btn btn-lg default"
                  onClick={props.handleCancel}
                >
                    Cancel
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  )

Form.defaultProps = {
  data: {
    subject: '',
    category: '',
    group: '',
    type: '',
    template: '',
    content: '',
  },
  emailTemplate: '',
  emailContent: '',

}

Form.propTypes = {
  data: PropTypes.shape({
    subject: PropTypes.string,
    category: PropTypes.string,
    group: PropTypes.string,
    type: PropTypes.string,
    template: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
  editorState: PropTypes.shape({}).isRequired,
  concateTemplate: PropTypes.string.isRequired,
  addEmail: PropTypes.func.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleEditorChange: PropTypes.func.isRequired,

}

export default Form
